
export class reloadWindow {

    constructor() {

    }

    prepare() {
        var reloadWindowWrapper = document.createElement('div');
        reloadWindowWrapper.classList.add("reloadWindowWrapper");
        document.body.prepend(reloadWindowWrapper);

        reloadWindowWrapper.innerHTML += this.getMenu();

        var menu = document.getElementsByClassName("reloadWindowWrapper")[0];
        menu.style.display = "none";
        this.init();
    }


    async show() {
        var menu = document.getElementsByClassName("reloadWindowWrapper")[0];
        menu.style.display = "grid";
    }



    init() {

        var reloadWindowAction = document.getElementsByClassName("reloadWindowAction")[0];
        reloadWindowAction.addEventListener('mousedown', this.reload.bind(this), false);

    }

    // Proccessors

    reload() {
        document.location.reload(true);
    }




    // Templates


    getMenu() {

        var template = `
            <div class="reloadWindow">
                <div class="reloadWindowInfo">Что-то пошло не так.<br>Пожалуйста перезагрузите страницу.</div>    
                <div class="reloadWindowAction">Перезагрузить</div>
            </div>
        `;

        return template;
    }
}